// extracted by mini-css-extract-plugin
module.exports = {"swiperA":"swiperA_swiperA__PTwlP"};